<template>
    <div class="f-topic-reply-list" v-if="hasReplyInfo">
        <span class="f-topic-reply-list-avatar">
            <avatar :user-info="replyInfo.userInfo"></avatar>
        </span>
        <div class="f-topic-reply-list-info" >
            <div>
                <span v-if="!replyInfo.rootId" class="f-topic-reply-list-info-floor">#{{replyInfo.floor}}</span>
                <span v-if="!replyInfo.rootId" class="f-topic-reply-list-info-border">·</span>
                <nick-name class="f-topic-reply-list-info-username"
                    :user-info="replyInfo.userInfo"></nick-name>
                <img v-if="replyInfo.userInfo.isOfficial" class="f-topic-reply-list-info-icon" :src="verity">
                <span class="f-topic-reply-list-info-time">{{isBoardInfo}}于{{replyInfo.replyTime}}</span>
            </div>
            <div class="f-topic-reply-list-info-content">
                <rich-text :html-snip="replyInfo.content"></rich-text>
            </div>
            <div v-if="replyInfo.replyList2">
                <div class="f-topic-reply-list-info-quote" 
                    v-show="!showReply"
                    v-for="(item, index) in replyInfo.replyList2" :key="index">
                    <div :class="['f-topic-reply-list-info-quote-padding', replyInfo.replyList2.length - 1 !== index ? 'f-topic-reply-list-info-quote-bottom' : '']">
                        <div class="f-topic-reply-list-info-quote-line-1">
                            <nick-name
                                class="f-topic-reply-list-info-username"
                                :user-info="item.userInfo"
                            ></nick-name>
                            <img v-if="item.userInfo.isOfficial" class="f-topic-reply-list-info-icon" :src="verity">
                            <span class="f-topic-reply-list-info-time" v-if="item.replyToUserInfo.username || item.replyToUserInfo.length != 0">{{isBoardInfo}}</span>
                            <nick-name
                                v-if="item.replyToUserInfo.username || item.replyToUserInfo.length != 0"
                                class="f-topic-reply-list-info-username"
                                :user-info="item.replyToUserInfo"
                            ></nick-name>
                            <img v-if="item.replyToUserInfo.isOfficial" class="f-topic-reply-list-info-icon" :src="verity">
                            <span class="f-topic-reply-list-info-time">{{isBoardInfo}}于{{item.replyTime}}</span>
                        </div>
                        <!-- 二级回复 -->
                        <div class="f-topic-reply-list-info-content">
                            <div :class="item.isShowMore || item.isHeight ? 'f-topic-reply-list-info-quote-line-2-more' : 'f-topic-reply-list-info-quote-line-2'">
                                <rich-text :html-snip="item.content"></rich-text>
                            </div>
                        </div>
                        <div class="f-topic-reply-list-info-operation f-topic-reply-list-info-newoperation">
                            <!-- 系统管理员 & 回复本人可以删回复 -->
                            <delete-icon
                                v-if="hasSystemPermission || canDelReply"
                                del-type="reply"
                                @replyDel="operateReply('delReply', item.replyId)">
                            </delete-icon>
                            <reply-icon @reply="replyTopic(item)"></reply-icon>
                        </div>
                        <div v-if="item.judgeReply">
                            <div
                                class="f-topic-reply-list-info-quote-line-3"
                                @click="showMoreReply(item)">
                                <span>{{!item.isShowMore ? '展开' : '收起'}}</span>
                                <span :class="!item.isShowMore ? 'fa fa-caret-down' : 'fa fa-caret-up'"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="f-topic-reply-list-info-page"
                    v-show="!showReply"
                    v-if="replyInfo.pageInfo2.recordTotal > replyInfo.pageInfo2.pageSize">
                    <el-pagination
                        :small="true"
                        layout="prev, pager, next"
                        @current-change="currentClick($event, replyInfo.replyId)"
                        :page-count="replyInfo.pageInfo2.pageTotal">
                    </el-pagination>
                </div>
                <div
                    v-if="replyInfo.pageInfo2.recordTotal > replyInfo.pageInfo2.pageSize"
                    class="f-topic-reply-list-info-load"
                >
                    <div
                        v-if="replyInfo.pageInfo2.pageNo < replyInfo.pageInfo2.pageTotal && !showOpen"
                        @click="more(replyInfo.replyId)">
                    查看更多</div>
                </div>
                <div class="f-topic-reply-list-info-quote-line-3 f-topic-reply-list-info-quote-line-toright"
                    @click="isShowReply"
                    v-if="replyInfo.replyList2.length"
                >
                    <span>{{!showReply ? '收起' + isBoardInfo : '展开' + isBoardInfo}}</span>
                    <span :class="showReply ? 'fa fa-caret-down' : 'fa fa-caret-up'"></span>
                </div>
            </div>
        </div>

        <div class="f-topic-reply-list-info-operation">
            <!-- 系统管理员 & 回复本人可以删回复 -->
            <delete-icon
                v-if="hasSystemPermission || canDelReply"
                del-type="reply"
                @replyDel="operateReply('delReply')">
            </delete-icon>
            <reply-icon @reply="replyTopic"></reply-icon>
        </div>
    </div>
</template>

<style lang="less">
    @import '../../../assets/less/views/topic-content/reply-list.less';
</style>

<script>
import RichText from '@/views/components/rich-text';
import ReplyIcon from './icon/ReplyIcon';
import DeleteIcon from './icon/DeleteIcon';
import NickName from '@/components/NickName';
import Avatar from '@/components/Avatar';
import {throttle} from '@/utils/debounceThrottle.js';
import toast from '@/utils/decorate/toast';
import {Tip} from '@/utils/errorCode';
import {limitMaxNum} from '@/utils/matchFilter';
import {classStr} from '@/utils/classes';
import {mapState, mapGetters} from 'vuex';

export default {
    props: {
        replyInfo: {
            'type': Object,
            'default': () => {
                return {};
            }
        },
        isTop: {
            'type': Number,
            'default': 0
        }
    },
    components: {
        'rich-text': RichText,
        'reply-icon': ReplyIcon,
        'delete-icon': DeleteIcon,
        'nick-name': NickName,
        'avatar': Avatar
    },
    data() {
        return {
            isShowMore: false,
            verity: require('@/assets/images/icon-official.png'),
            showReply: false,
            pageInfoNo: {},
            replyToInfoStyle: '',
            isBoardInfo: '',
            page: 1,
            showOpen: false,
            feedback: false
        };
    },
    created() {
        this.isBoardInfo = this.boardInfo.id === 1 ? '回答' : '回复';
        this.judgeReplyToInfo();
    },
    watch: {
        replyInfo() {
            this.judgeReplyToInfo();
        }
    },
    methods: {

        /**
         * 小程序点击展开
         *
         * @param {number} replyId 二级帖子的id
         */
        more(replyId) {
            this.$store.dispatch('getReplyContentTwo', {replyId, pageNo: ++this.page})
                .then(data => {
                    this.replyInfo.pageInfo2 = data.pageInfo2;
                    this.replyInfo.replyList2.push(...data.replyList2);
                    this.judgeReplyToInfo();
                })
                .catch(errmsg => toast.error(errmsg));
        },

        /**
         * 二级分页点击
         *
         * @param {number} val 点击二级分页的页数
         * @param {number} replyId 二级帖子的id
         */
        currentClick(val, replyId) {
            this.$store.dispatch('getReplyContentTwo', {replyId, pageNo: val})
                .then(data => {
                    this.pageInfoNo = data.pageInfo2;
                    this.replyInfo.replyList2 = data.replyList2;
                    this.judgeReplyToInfo();
                })
                .catch(errmsg => toast.error(errmsg));
        },

        /**
         * 点击【反馈原因】和【反馈已完成】
         *
         * @param {number} replyId 帖子的id
         * @param {string} name 根据name来区分点击为【反馈原因】和【反馈已完成】
         */
        clickFeedback(replyId, name) {
            if (!this.feedback) {
                this.feedback = true;
                let type = 0;
                let feedbackId;
                let newDispatchName;
                if (name === 'questionFeedback') {
                    feedbackId = this.questionFeedbackId;
                    newDispatchName = 'clickQuestionFeedback';
                }
                else if (name === 'fixedFeedback') {
                    feedbackId = this.fixedFeedbackId;
                    newDispatchName = 'clickFixedFeedback';
                }
                type = feedbackId === replyId ? 0 : 1;
                this.$store.dispatch(newDispatchName, {replyId, type})
                    .then(() => {
                        this.feedback = false;
                    });
            }
        },

        /**
         * 回复
         *
         * @param {object} item 列表每一项的值
         */
        replyTopic(item) {
            if (this.isLogin) {
                if (this.isBanned) {
                    toast.error(Tip.banned);
                }
                else {
                    this.$emit('operate', {
                        type: 'reply',
                        query: {
                            floor: item ? '' : this.replyInfo.floor,
                            replyId: item ? item.replyId : this.replyInfo.replyId,
                            userName: item ? item.userInfo.nickname : this.replyInfo.userInfo.nickname
                        }
                    });
                }
            }
            else {
                this.$emit('operate', {
                    type: 'toast',
                    query: {
                        type: 'login'
                    }
                });
            }
        },

        /**
         * 展开收起
         *
         * @param {object} item 列表每一项的值
         */
        showMoreReply(item) {
            this.replyInfo.replyList2.forEach((itemData, indexData) => {
                if (itemData.replyId === item.replyId) {
                    itemData.isShowMore = !itemData.isShowMore;
                }
            });
            this.replyInfo.replyList2.splice(0, 0);
        },

        /**
         * 推荐、采纳、删除
         *
         * @param {string} type 区分是【推荐】、【采纳】、【删除】
         * @param {number} replyId 帖子的id
         */
        operateReply(type, replyId) {
            this.$emit('operate', {
                type: 'toast',
                query: {
                    type,
                    replyId: replyId ? replyId : this.replyInfo.replyId
                }
            });
        },

        /**
         * 展开收起二级回复
         */
        isShowReply() {
            if (!this.showReply) {
                this.showReply = true;
                this.showOpen = true;
                return;
            }
            this.showOpen = false;
            this.showReply = false;
        },

        /**
         * 回复内容限制
         */
        judgeReplyToInfo() {
            if (this.hasReplyToInfo && this.replyInfo.replyList2) {
                this.replyInfo.replyList2.forEach((item, index) => {
                    item.isShowMore = false;
                    item.judgeReply = false;
                    const content = item.content;
                    // 匹配html标签
                    const p = /<\/?.+?\/?>/g;
                    const textLen = content.replace(p, matched => '').length;
                    if (textLen < 50) {
                        item.isHeight = true;
                    }
                    // 文本超过50
                    else if (textLen > 75) {
                        item.judgeReply = true;
                    }

                    else if (content.match(p) && content.match(p).length > 0) {
                        let firstTag = content.match(p)[0];
                        if (firstTag.indexOf(' ') > -1) {
                            let idx = firstTag.indexOf(' ');
                            firstTag = firstTag.slice(0, idx) + '>';
                        }
                        // 首行
                        if (firstTag === '<pre>' || firstTag === '<ol>' || firstTag === '<ul>') {
                            item.judgeReply = true;
                        }
                        // 首行图片
                        item.judgeReply = content.match(p)[1].indexOf('img') > -1;

                        // 出现换行
                        let firstCloseTag = firstTag.slice(0, 1) + '/' + firstTag.slice(1);
                        if (content.indexOf(firstCloseTag) < content.length - firstCloseTag.length - 2) {
                            item.judgeReply = true;
                        }
                    }
                });
            }
        }
    },
    computed: {
        ...mapState({
            isLogin: state => state.header.isLogin,
            isBanned: state => state.header.isBanned,
            userNo: state => state.header.userNo,
            topicData: state => state.topicContent.topicData,
            questionFeedbackId: state => state.topicContent.questionFeedbackId,
            fixedFeedbackId: state => state.topicContent.fixedFeedbackId,
            boardInfo: state => state.topicContent.topicData.boardInfo
        }),
        ...mapGetters([
            'hasSystemPermission',
            'canEditTopic',
            'hasStickyReply',
            'hasShowOfficialBoard'
        ]),
        hasReplyInfo() {
            return Object.keys(this.replyInfo).length;
        },
        canDelReply() {
            if (this.hasReplyInfo) {
                return this.userNo === this.replyInfo.userInfo.userNo;
            }
            return false;
        },
        evaluationCount: {
            get() {
                return limitMaxNum(this.replyInfo.evaluationCount);
            }
        },
        hasReplyToInfo() {
            if (this.hasReplyInfo && this.replyInfo.replyList2) {
                return this.replyInfo.replyList2.length;
            }
            return false;
        }
    }
};
</script>